import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    saveSQLAdapter(sqlAdapterDto, externalSystemId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/externalsystems/" + externalSystemId + "/apis/" + apiId + "/sqladaptersAPI/saveSqlAdapter", sqlAdapterDto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    getAPIInfo(externalSystemId, apiId) {
        var msgType = "getSuccess";
        return axios.get(constants.BASE_URL + "/integrate/externalsystems/" + externalSystemId + "/apis/" + apiId + "/sqladaptersAPI/getAPIInfo", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "getError";
            }).finally(() => {
                if (msgType == 'getError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching api info"
                    });
                }
            });
    },
    getAdapterInfo(externalSystemId, apiId, sqlAdapterId) {
        var msgType = "getSuccess";
        return axios.get(constants.BASE_URL + "/integrate/externalsystems/" + externalSystemId + "/apis/" + apiId + "/sqladaptersAPI/getAdapterInfo/" + sqlAdapterId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "getError";
            }).finally(() => {
                if (msgType == 'getError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching sql adapter info"
                    });
                }
            });
    },
    deleteSqlAdapter(externalSystemId, apiId, sqladapterId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/externalsystems/" + externalSystemId + "/apis/" + apiId + "/sqladaptersAPI/deleteSqlAdapter/" + sqladapterId).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    testAdapter(sqlAdapterDto, externalSystemId, apiId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/integrate/externalsystems/" + externalSystemId + "/apis/" + apiId + "/sqladaptersAPI/testconnection", sqlAdapterDto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }
}